// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-blog-post-js": () => import("../src/templates/blog-post.js" /* webpackChunkName: "component---src-templates-blog-post-js" */),
  "component---src-templates-main-js": () => import("../src/templates/main.js" /* webpackChunkName: "component---src-templates-main-js" */)
}

